$.fn.datatableAddition = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _checkAllObj = $('input[type="checkbox"].check-all');

    // custom variables
    var o = $.extend({

    }, options);

    _this.init = function() {
        // check all checkboxes in current view
        _checkAllObj.on('click', function() {
            var checked = $(this).prop('checked');

            _this.toggleCheckAll(checked);
        });

        // check to turn on or off the visible objects
        _elem.find('input[type="checkbox"]').on('click', function() {
            if (_this.watchChecks() >= 1)
            {
                _this.toggleVisibleObjects('show');
            }
            else
            {
                _this.toggleVisibleObjects('hide');
            }
        });

        // Move all items to trashcan
        $('#material-actions .trash').on('click', function() {
            var objArray = _this.GetCheckedRows();

            _this.MoveSelectedItems(objArray, 'moveToTrash');
        });

        // Move all items from trashcan
        $('#material-actions .restore').on('click', function() {
            var objArray = _this.GetCheckedRows();

            _this.MoveSelectedItems(objArray, 'restore');
        });

        $('#material-actions .duplicate').on('click', function() {
            var objArray = _this.GetCheckedRows()[0];
            window.location = '/_cms/questionanswers/copy/' + objArray;
        });
    };

    // Ajax call to do something with all selected items based on action given
    _this.MoveSelectedItems = function(objArray, action) {
        var postUrl = _elem.find('table').data('url');

        $('#confirmation-modal').modal({
            onShow: function() {
                /*
                    Hack for bad positioning
                 */
                setTimeout(function () {
                    $('#confirmation-modal').modal('refresh');
                }, 1);
            },
            onApprove: function() {
                $.ajax(postUrl, { data: {ajax: 1, action: action, objArray: objArray},
                    type: 'POST',
                    error: function(data) {
                        console.log(data);
                    },
                    success: function(data) {
                        console.log(data);

                        var response = jQuery.parseJSON(data);

                        if (response.status == 'success')
                        {
                            _elem.find('tbody td.check-col input[type="checkbox"]:checked').each(function() {
                                $(this).parents('tr').fadeOut(400, function() {
                                    $(this).remove();
                                });
                            });

                            var messenger = new Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'success',
                                showCloseButton: true
                            });
                        }
                    }
                });
            }
        }).modal('show');
    };

    // Get all checked items in current list
    // returns array with all values from checkboxes (basically id's from items)
    _this.GetCheckedRows = function() {
        var objArray = [];

        _elem.find('tbody td.check-col input[type="checkbox"]:checked').each(function() {
            var thisId = $(this).val();

            objArray.push(thisId);
        });

        return objArray;
    };

    // watch and returns amount of checkboxes count
    _this.watchChecks = function() {
        var countChecks = _elem.find('input[type="checkbox"]:checked').length;

        return countChecks;
    };

    // toggles objects which have to become visible if at least one checkbox is checked
    // usage:
    // <div class="visible-on-check [is-visible/not-visible]">
    _this.toggleVisibleObjects = function(visibility) {
        if (visibility == 'show')
            $('.visible-on-check').removeClass('not-visible').addClass('is-visible');
        else
            $('.visible-on-check').removeClass('is-visible').addClass('not-visible');
    };

    // toggle all checkboxes
    _this.toggleCheckAll = function(checked) {
        _elem.find('table tbody .checkbox-wrapper input[type="checkbox"]').each(function() {
            if (checked === true)
            {
                $(this).prop('checked', true);
            }
            else
            {
                $(this).prop('checked', false);
            }
        });
    };

    _this.init();
};